<div class="box ml-2  mr-2">
  <div class="box-header">

    <div class="box-body">
      <form [formGroup]="exceptionForm">
        <div class="col form">
          <div class="row" style="justify-content: center;">


            <div class="col">


              <mat-form-field appearance="outline">
                <mat-label>{{'From Date' | translate}}</mat-label>
                <input matInput [max]="maxDate" [matDatepicker]="picker" formControlName="fromDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>




            </div>

            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{'To Date' | translate}}</mat-label>
                <input matInput [max]="maxDate" [matDatepicker]="todate" formControlName="toDate">
                <mat-datepicker-toggle matSuffix [for]="todate"></mat-datepicker-toggle>
                <mat-datepicker #todate></mat-datepicker>
              </mat-form-field>


              <!-- <button mat-raised-button  class="ml-2 mt-2 ml-sm-auto" [disabled]="!poSummaryForm.valid" (click)="getPOOrderData()">
              {{'Filter' | translate}}
            </button> -->

          </div>

          @if (userData.roleId<4) {
            <div class="col">
              <!-- <mat-form-field appearance="outline">
              <mat-label>{{'DC Location' | translate}}</mat-label>
              <input matInput maxlength="6" formControlName="storeNumber" (keyup.enter)="getPOOrderData()" />
            </mat-form-field> -->
            <mat-form-field class="example-full-width" appearance="outline" >
              <mat-label>{{'DC Location' | translate}}</mat-label>
              <input type="text" matInput formControlName="dcNumber" [matAutocomplete]="auto" (blur)="dcOnchange()">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @for (dc of user.dcLocations; track dc) {
                  <mat-option [value]="dc.dcNumber">
                    {{dc.dcLocation}} - {{dc.dcName}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }

        <div class="col">


          <!-- <mat-form-field appearance="outline">
          <mat-label>{{'Store No' | translate}}</mat-label>
          <input matInput maxlength="6" formControlName="storeNumber" (keyup.enter)="getPOOrderData()" />

        </mat-form-field> -->


        <mat-form-field appearance="outline">
          <mat-label>{{'Store No' | translate}}</mat-label>
          <input type="text"
            required
            aria-label="Number"
            matInput
            specialCharctersRestrict
            maxlength="6"
            formControlName="storeNumber"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of filteredStoreOptions | async; track option) {
              <mat-option [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>



      </div>

      <div class="col">

        <button mat-raised-button  class="ml-2 mt-3 ml-sm-auto" (click)="getExceptionesults()"  [disabled]="!exceptionForm.valid">
          {{'Filter' | translate}}
        </button>
      </div>






    </div>


  </div>
</form>
</div>


</div>

<div class="box-body">
  <div class="box">
    <div class="box-body mt-3">
      <mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)"
        matSortDirection="desc">
        <!-- Position Column -->
        <ng-container matColumnDef="purchaseOrder">
          <mat-header-cell  *matHeaderCellDef mat-sort-header>
          {{'RC Number' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element" >
            <a (click)="openReportBySeq(element.sequenceNumber)" class="nav-link" [routerLink]="[this.router.url]" >
              {{ element.purchaseOrder}}
            </a>

          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="poCreatedTime">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
          {{'RC Date' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.poCreatedTime | date : dateTimeFormat :'' : 'fr'}} </mat-cell>
        </ng-container>



        <!-- Symbol Column -->
        <ng-container matColumnDef="poReceivedDate">
          <mat-header-cell  *matHeaderCellDef mat-sort-header
          disableClear> {{'Received Date' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let element">
          {{ element.receivedDate? (element.receivedDate | date : dateFormat:'' : 'fr'):'N/A' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="signedBy">
          <mat-header-cell matTooltip="{{'SignedByTooltip' | translate}}" *matHeaderCellDef mat-sort-header
          disableClear> {{'Signed By' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ (element.poSignedBy? element.poSignedBy : 'N/A') | translate }}
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns">
        </mat-row>
      </mat-table>


    </div>
    <div class="box-footer">
      <mat-paginator [length]="resultsLength" [pageSize]="15" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>